(function () {
  function getMonthName() {
    var now = new Date();
    var next = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    var locale = navigator.language || "en-US";
    try {
      return new Intl.DateTimeFormat(locale, { month: "long" }).format(next);
    } catch (e) {
      return next.toLocaleDateString("en-US", { month: "long" });
    }
  }

  function setMonth() {
    var el = document.querySelector(".pf-next-month-name");
    if (!el) return false;
    el.textContent = getMonthName();
    return true;
  }

  function init() {
    if (setMonth()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (setMonth() || tries >= 40) clearInterval(timer);
    }, 250);

    if (window.MutationObserver) {
      var obs = new MutationObserver(function () { setMonth(); });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
